// Import all edge type components
import Straight from "./StraightEdge";
import Curved from "./CurvedEdge";
import Bezier from "./BezierEdge";
import Orthogonal from "./OrthogonalEdge";
import Polyline from "./PolylineEdge";
import Round from "./RoundEdge";
import Spline from "./SplineEdge";
import Loop from "./LoopEdge";
import Arc from "./ArcEdge";
import Perimeter from "./PerimeterEdge";
import SideToSideEdge from "./SideToSideEdge";
import TopToBottomEdge from "./TopToBottomEdge";
import EntityRelationEdge from "./EntityRelationEdge";

// Registry: maps edge.type → component
export const registry = {
  straight: Straight,
  curved: Curved,
  bezier: Bezier,
  orthogonal: Orthogonal,
  elbow: Orthogonal,    // alias
  polyline: Polyline,
  rounded: Round,
  spline: Spline,
  loop: Loop,
  arc: Arc,
  perimeter: Perimeter,
  sidetoside: SideToSideEdge,
  toptobottom: TopToBottomEdge,
  entityrelation: EntityRelationEdge,
};

// Default export
export default registry;

